import ConfiguratorTemplate from '../ConfiguratorTemplate';
import SixteenthInchDropdown from '../../../components/SixteenthInchDropdown';
// eslint-disable-next-line import/no-cycle
import WithCustomSizing from '../withCustomSizing';

export default ConfiguratorTemplate(WithCustomSizing(SixteenthInchDropdown));
